module.exports = __webpack_public_path__ + "media/src/images/icons/twitter-b743eaac4197eca65f397dcbb84b8c94.svg";